import { apiHandlerWithError } from 'api/apiHandler';
import addQueryParams from 'api/addQueryParams';

export default async function verifyEmail(userId, confirmationToken) {
  return await apiHandlerWithError(
    addQueryParams('users/register', { user_id: userId, confirmation_token: confirmationToken })
  );
}
